import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';

export class ReactFormFieldEmailInput extends PureComponent {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    
    handleInputChange(e) {
        if(this.props.onChange)
            this.props.onChange(e.target.value);
    }

    render() {
        const EmailInputView = this.props.viewProvider.getEmailInputView();
        const name = this.props.isMultilingual ? this.props.name[this.props.lang] : this.props.name;

        return (
            <ReactFormGroupWrapper {...this.props}>
                <EmailInputView
                    name={name}
                    value={this.props.value}
                    onChange={this.handleInputChange} 
                    isRequired={this.props.isRequired}
                    isInvalid={this.props.showValidationErrors}
                />
                    
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormFieldEmailInput.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    validationErrors: PT.array,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    isRequired: PT.bool,
    isMultilingual: PT.bool,
    lang: PT.string
};

ReactFormFieldEmailInput.defaultProps = {
    value: "" 
};
